import CodeMirrorInput from "./CodeMirrorInput";
import UploadFormChild from "./UploadExcel";
import { Dropdown, Input, MenuProps, Form, Radio, RadioChangeEvent, FormInstance } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import './index.less'
import { filterNotNumber, toThousands } from "@/utils";
import { generateResults, calculateTotalBalances } from "./wallet";
import { cdnUrl } from "@/utils/cdn";
import { isSuiCoinType } from "@/utils/suiMethods";

interface IProps {
  provider: any
  form: FormInstance;
  token: any
}

const FormAddrsChild = ({ form, mode, setMode, setIsUploadFileSuccess, ...restProps }: any) => {
  // const { form, mode, setMode, setIsUploadFileSuccess } = props
  // const props = {
  //   form,
  //   mode,
  //   setMode,
  //   setIsUploadFileSuccess
  // }
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <a target="_blank" href={cdnUrl("/demo/xlsx-key-demo.xlsx")} download>
          Excel
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a target="_blank" href={cdnUrl("/demo/csv-key-demo.csv")} download>
          CSV
        </a>
      )
    },
    {
      key: '3',
      label: (
        <a target="_blank" href={cdnUrl("/demo/txt-key-demo.txt")} download>
          TXT
        </a>
      ),
    },
    {
      key: '4',
      label: (
        <a target="_blank" href={cdnUrl("/demo/json-key-demo.json")} download>
          JSON
        </a>
      ),
    },
  ];

  function onDone(value: any = '') {
    console.log('onDone value', value);

    form.setFieldValue('keypair', value)
    setMode(1)
  }

  function onError(bol: any = false) {
    setIsUploadFileSuccess(bol)
  }

  function onInputCode(value: any) {
    const trimmedValue = value.replace(/ /g, ''); // 去掉所有空格
    console.log(trimmedValue, 'value 123123');
    // setFormAddresses(trimmedValue);
    form.setFieldValue('keypair', trimmedValue);
  }

  const { t } = useTranslation()
  const placeholder = `0x7b23de66a603f133823c422ce7aa682ef42abd21cf10ec1db7f4589e6553419f`
  return (
    <div>
      <Input {...restProps} type={'hidden'} />
      {
        mode === 2 ? <UploadFormChild onDone={onDone} /> : <CodeMirrorInput placeholder={placeholder} code={form.getFieldValue('keypair')} onInputCode={onInputCode} onError={onError} />
      }
      {/* <div className='demo-box'>
          <p></p>
        <Dropdown menu={{ items }} trigger={['click']}>
          <a onClick={(e) => e.preventDefault()}>
            {
              t("components.TemplateFile")
            }
          </a>
        </Dropdown>
        </div> */}
    </div>
  )
}

export default function ImportWalletKey({ client, form, basicInfo }: any) {
  const { t } = useTranslation()
  const [opType, setOpType] = useState('simple')
  const [mode, setMode] = useState(1);
  const [isUploadFileSuccess, setIsUploadFileSuccess] = useState(false)
  const keypairForm = Form.useWatch('keypair', form);
  const mint = Form.useWatch('selectedToken', form);
  const [list, setList] = useState([])
  const [wallets, setWallets] = useState<any>([])
  const [progress, setProgress] = useState<any>(0);
  const [loading, setLoading] = useState<any>(false);
  const [totalSelectedTokenBalance, setTotalSelectedTokenBalance] = useState<any>(0);
  const [totalSelectedBalance, setTotalSelectedBalance] = useState<any>(0);

  async function queryData() {
    setLoading(true);
    try {
      const results = await generateResults(client, keypairForm, basicInfo, 500, basicInfo.coinType);
      console.log("results111111", results)
      const { totalSelectedBalance, totalSelectedTokenBalance } = calculateTotalBalances(results)
      console.log("totalSelectedBalance", totalSelectedBalance)
      console.log("totalSelectedTokenBalance", totalSelectedTokenBalance)
      setTotalSelectedTokenBalance(totalSelectedTokenBalance)
      setTotalSelectedBalance(totalSelectedBalance)
      // setWallets(results);
    } catch (error) {
      console.error("Failed to generate results:", error);
    } finally {
      setLoading(false);
    }
  }

  const options = [
    { label: t("components.manualInput"), value: 1 },
    { label: t("components.uploadFile"), value: 2 }
  ];

  const onChangeMode = ({ target: { value } }: RadioChangeEvent) => {
    console.log('radio3 checked', value);
    setMode(value);
  }

  useEffect(() => {
    if (keypairForm) {
      setList(keypairForm.trim().split('\n'))
      setTimeout(() => {
        queryData()
      }, 100);
    }
  }, [keypairForm, mint, basicInfo])

  return (<div className="import-wallet-key">
    <div className="form-addrs-head-wrap">
      <div className='addrs-head'>
        <div className='title'>{t("manyToMany.senderAddressPrivateKey")}</div>
        <Radio.Group options={options} onChange={onChangeMode} value={mode} optionType="button" className='option-mode' />
      </div>
    </div>
    <Form.Item
      label=""
      name={"keypair"}
      rules={[{ required: true, message: t("components.manuallyEnterOrUploadPrivateKey") }]}
    >
      <FormAddrsChild form={form} mode={mode} setMode={setMode} setIsUploadFileSuccess={setIsUploadFileSuccess} />
    </Form.Item>
    <div className="addrs-footer-info">
      <div className="el">
        <strong>{t("manyToMany.numberOfAddresses")}</strong>
        <strong>{list.length > 0 ? list.length : '-'}</strong>
      </div>
      <div className="el">
        <strong>{t("manyToMany.balance", { symbol: basicInfo?.symbol }) + "："}</strong>
        {
          (Object.keys(basicInfo).length > 0) && isSuiCoinType(basicInfo.coinType)
          && <strong>{totalSelectedBalance} </strong>
          // <strong>{toThousands(filterNotNumber(totalSelectedTokenBalance)) !== '0' ? toThousands(filterNotNumber(totalSelectedTokenBalance)) : '-'}</strong>
        }
        {
          Object.keys(basicInfo).length > 0 && !isSuiCoinType(basicInfo.coinType)
          && <strong>{totalSelectedTokenBalance}</strong>
        }

      </div>
    </div>
  </div>)
}